export const formatPhoneNumber = (phoneNumber?: string) => {
  if (phoneNumber) {
    return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  return '';
};
